@if (authService.isAuthenticated()) {
    <wj-tab-panel class="full-size-tab" style="height:100%" [selectedIndex]="0" [isAnimated]="true"
                  appWjTabStatePersist tabStateKey="dashboard-targets-main-tab">
        <wj-tab>
            <a>User Profile</a>
            <div>
                <div class="user-avatar">
                    <i class="far fa-user-circle"></i>
                </div>

                <div class="details-panel">
                    <!-- User Info Section -->
                    <label>Name</label>
                    <div>{{ authService.appUser()?.name }}</div>

                    <label>Email</label>
                    <div>{{ authService.appUser()?.username }}</div>

                    <label>Roles</label>
                    <div>{{ accessControlSvc.userContext().roles }}</div>

                    <label>LoBs & Offices</label>
                    <div>{{ lobOffices() }}</div>

                    <label>Locale</label>
                    <div style="gap: 10px">
                        <wj-combo-box [itemsSource]="locales" displayMemberPath="name"
                                      [selectedItem] = "selectedLocale"
                                      (selectedItemChange)="onLocaleChange($event)">
                        </wj-combo-box>
                        <fluent-button [disabled]="!localeChanged()" (click)="onApplyLocaleChange(selectedLocale)">Apply</fluent-button>
                    </div>

                    <label>App Settings</label>
                    <div><fluent-button (click)="onClearAppSettingsCache()">Clear Cache</fluent-button></div>

                </div>
            </div>
        </wj-tab>

        <wj-tab>
            <a>Devtools</a>
            <div>
                <div class="details-panel">

                    <label>Developer Mode</label>
                    <div>{{ devToolsSvc.isDevMode() }}</div>

                    <label>Authority Type</label>
                    <div>{{ authService.appUser()?.authorityType }}</div>

                    <label>Home Account ID</label>
                    <div>{{ authService.appUser()?.homeAccountId }}</div>

                    <label>Environment</label>
                    <div>{{ authService.appUser()?.environment }}</div>

                    <label>Tenant ID</label>
                    <div>{{ authService.appUser()?.tenantId }}</div>

                    <label>Local Account ID</label>
                    <div>{{ authService.appUser()?.localAccountId }}</div>

                    @if (authService.appUser()?.nativeAccountId) {
                        <label>Native Account ID</label>
                        <div>{{ authService.appUser()?.nativeAccountId }}</div>
                    }

                    @if (authService.appUser()?.tenantProfiles) {
                        <label>Tenant Profiles</label>
                        <div>Available ({{ authService.appUser()?.tenantProfiles?.size }} profiles)</div>
                    }

                    <!-- Token Section -->
                    <label style="align-self: flex-start">Access Token</label>
                    <div class="layout-vbox" style="align-items: flex-start">
                        {{ authService.accessToken() | slice:0:100 }}...
                        <pre>{{ getDecodedAccessToken() | json }}</pre>
                        <fluent-button  (click)="copyAccessToken()">
                            <i class="far fa-copy"></i>
                        </fluent-button>
                    </div>


                    <label style="align-self: flex-start">ID Token</label>
                    <div class="layout-vbox" style="align-items: flex-start">
                        {{ authService.idToken() | slice:0:100 }}...
                        <pre>{{ getDecodedIdToken() | json }}</pre>
                        <fluent-button appearance="subtle" (click)="copyIdToken()">
                            <i class="far fa-copy"></i>
                        </fluent-button>
                    </div>

                </div>
                <div class="toolbar-horizontal">
                    <fluent-button (click)="onRefreshToken()">
                        <i class="far fa-refresh"></i> Refresh Token
                    </fluent-button>
                </div>
            </div>
        </wj-tab>
    </wj-tab-panel>

} @else {
    <div class="user-not-authenticated">
        <i class="far fa-user-circle"></i>
        <span>Not authenticated</span>
    </div>
}
